import type { ContactGroupSelection } from "@multi-chat/shared";

export type ContactGroupSelectionValue = {
  groupIds: number[];
  newGroupNames: string[];
};

export function emptyContactGroupSelection(): ContactGroupSelectionValue {
  return { groupIds: [], newGroupNames: [] };
}

export function contactGroupSelectionToRequest(
  value: ContactGroupSelectionValue,
): ContactGroupSelection {
  return {
    groupIds: value.groupIds.length > 0 ? value.groupIds : undefined,
    newGroupNames: value.newGroupNames.length > 0 ? value.newGroupNames : undefined,
  };
}

/** Update replaces all memberships; always send groupIds (may be empty). */
export function contactGroupSelectionToUpdateRequest(value: ContactGroupSelectionValue): {
  groupIds: number[];
  newGroupNames?: string[];
} {
  return {
    groupIds: value.groupIds,
    newGroupNames: value.newGroupNames.length > 0 ? value.newGroupNames : undefined,
  };
}
